module.exports = __webpack_public_path__ + "static/img/guellpark.8aaef3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/guellpark.jpg
// module id = vRJN
// module chunks = 1